import React from "react";
import Header from "./header";
import Footer from "./footer";

type Props = {
  children: React.ReactNode;
  darkNav?: boolean;
};

function Layout({ children, darkNav = false }: Props) {
  return (
    <>
      <Header darkNav={darkNav} links={navLinks}></Header>
      <main>{children}</main>
      <Footer></Footer>
    </>
  );
}

export default Layout;

const navLinks = [
  {
    link: "/#payment-options",
    text: "Payment Options",
  },
  {
    link: "/dealers",
    text: "Dealers",
  },
  {
    link: "#contact-us",
    text: "Contact Us",
  },
  {
    link: "https://spectrum.accountportalonline.com/",
    text: "Login",
  },
];
